<template>
  <div class="UpdatePassword">
    <div class="page-module">
        <p class="title">修改密码</p>
        <div class="input">
            <span>当前密码</span>
            <input type="password" name="password" style="width:0;height:0;">
            <el-input v-model="oldPassword" type="password"  placeholder="请输入当前密码"></el-input>
        </div>
        <div class="input">
            <span>新密码</span>
            <el-input v-model="newPassword" type="password"  placeholder="请输入新密码"></el-input>
        </div>
        <div class="input">
            <span>确认密码</span>
            <el-input v-model="newPasswordTwo" type="password" placeholder="请再次输入新密码"></el-input>
        </div>
        <el-button type="primary" @click="updatePassword">确认修改</el-button>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import {mapActions, mapGetters} from 'vuex'
import {resetPassBycenter} from 'api/api'
export default {
  name: 'UpdatePassword',
  data () {
    return {
        oldPassword: '',    // 旧密码
        newPassword: '',    // 新密码
        newPasswordTwo: ''  // 再次输入密码
    }
  },
  mounted () {
      $('html').scrollTop(0)
      if (!this.user().isLogin) {
          this.setLoginPop(true)
      }
  },
  methods: {
      updatePassword() {    // 修改密码
        if (this.oldPassword.length == 0 || this.newPassword.length == 0 || this.newPasswordTwo.length == 0) {
            this.$message.error('密码不能为空')
            return false
        } else if (this.newPassword !== this.newPasswordTwo) {
            this.$message.error('两次密码输入不正确，请重新输入')
            return false
        } else if(this.newPasswordTwo.length < 6 || this.newPasswordTwo.length > 16) {
            this.$message.error('密码长度为6-16位，请注意区分大小写')
        } else {
            
            this.setLoading(true)

            resetPassBycenter({
                data: {oldpassword: this.oldPassword, password: this.newPasswordTwo},
                success: data => {
                    this.setLoading(false)
                    if (data.code == '000') {

                        this.$message.success('修改密码成功，请重新登录')

                        setTimeout(() => {
                            window.sessionStorage.clear()
                            let user = {
                                innerid: '',
                                loginToken: '',
                                loginname: '',
                                logourl: '',
                                mobile: '',
                                name: '',
                                nickname: '',
                                isLogin: false
                            }
                            this.setUser(user)
                            this.$router.push({name: 'GJIndex'})
                            setTimeout(() => {
                                this.setLoginPop(true)
                            }, 400)
                        }, (600))

                    } else {
                        this.$message.error(data.msg)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        }
        
      },
      ...mapActions(['setLoading','setUser', 'setLoginPop']),
      ...mapGetters(['user'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.UpdatePassword {
    padding: 30px;
    padding-bottom: 261px;
    background: #F8F8F8;
    text-align: center;
    .page-module {
        margin-top: 120px;
        padding-top: 40px;
        padding-bottom: 243px;
        background: #fff;
    }
    p.title {
        font-size: 16px;
        font-weight: bold;
    }
    .input {
        margin-top: 28px;
        span {
            display: inline-block;
            width: 56px;
        }
        .el-input {
            margin-left: 24px;
            width: 283px;
            input {
                width: 100%;
            }
        }
    }
    .el-button {
        margin-top: 32px;
    }
}
</style>